module.exports = require("core-js/library/fn/object/entries");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime-corejs2/core-js/object/entries.js
// module id = 67
// module chunks = 0